import React, {createContext, useState, useContext, ReactNode, useEffect} from 'react';
import {GameEvent} from "../reactvideoeditor/pro/components/advanced-timeline/types";


// 2. Definisci il tipo di dato che il Context esporrà
interface TimelineEventContextType {
    clipEvents: TimelineEvents;
    setClipEvents: React.Dispatch<React.SetStateAction<TimelineEvents>>;
    timelineJumpToTime: number | null;
    setTimelineJumpToTime: React.Dispatch<React.SetStateAction<number | null>>;
}

// 3. Crea il Context
const TimelineEventContext = createContext<TimelineEventContextType | undefined>(undefined);

// 4. Definisci le props del Provider
interface TimelineEventProviderProps {
    children: ReactNode;
}

interface TimelineEvents{
    events: GameEvent[],
    stream_url: string
}

// 5. Crea il componente Provider
export const TimelineEventProvider: React.FC<TimelineEventProviderProps> = ({ children }) => {
    const [clipEvents, setClipEvents] = useState<TimelineEvents>({events: [], stream_url: ''});
    //Necessario per triggerare spostamento della timeline senza distruggerne la struttura per far salire il ref fino all'header
    const [timelineJumpToTime, setTimelineJumpToTime] = useState<number | null>(null);

    return (
        <TimelineEventContext.Provider value={{ clipEvents, setClipEvents, timelineJumpToTime, setTimelineJumpToTime}}>
            {children}
        </TimelineEventContext.Provider>
    );
};

// 6. Crea un Custom Hook per consumare il context in modo sicuro e pulito
export const useTimelineEvents = (): TimelineEventContextType => {
    const context = useContext(TimelineEventContext);

    if (context === undefined) {
        throw new Error("useTimelineEvents deve essere utilizzato all'interno di un TimelineEventProvider");
    }

    return context;
};